<template>
  <!-- <card header-text="Users List"> -->
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">{{ 'Portfolio Report' }}</strong>
        </div>
        <!-- <div class="col-md-2">
          <download :tableId="'users'" :fileName="'portfolios-details'"></download>
        </div>-->
        <!-- <div class="col-md-1">
          <goback></goback>
        </div>-->
      </div>
    </div>
    <div class="card-body mb-15">
      <div class="row mb5">
        <!-- <div class="row mb5"> -->
        <div class="col-md-10">
          <h3 class="text-center">
            Since Inception
            <small>Date: {{ getDate(outputData.inception.inception_date || '') }}</small>
          </h3>
        </div>
        <!-- <div class="col-md-1"></div> -->
        <!-- </div> -->
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-11">
              <h4 class="text-left"></h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'inception-portfolio-value'" :fileName="'portfolio-value'"></download>
            </div>
          </div>
          <div class="table-responsive app mb-15" v-dragscroll="true">
            <table id="inception-portfolio-value" class="table table-sm first-td-padding table-bordered app-inner">
              <thead>
                <tr>
                  <th>Sr.</th>
                  <th v-for="field in stockTableFields" v-bind:key="'field' + field.title">{{ field.name }}</th>
                  <th v-if="actions.length > 0">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in outputData.inception.stockwise" v-bind:key="'row' + index">
                  <td>{{ index + 1 }}</td>
                  <td v-for="field in stockTableFields" v-bind:key="field.name">
                    <span v-if="field.type === 'string'">
                      <span v-if="field.title === 'industry_type'">{{ getCustomLabel(row[field.title]) }}</span>
                      <span v-else>{{ row[field.title] }}</span>
                    </span>
                    <span v-else-if="field.type === 'number'">{{ getFixed(row[field.title]) }}</span>
                    <span v-else-if="field.type === 'date'">{{ getDate(row[field.title]) }}</span>
                    <span v-else>{{ row[field.title] }}</span>
                  </td>
                  <td v-if="actions.length > 0">
                    <div class="action-btn-wrapper">
                      <a style="margin:1px 4px" class="btn btn-sm btn-small" :class="action.btnClass"
                        v-for="(action, index) in actions" v-bind:key="index + '-action-' + action.tooltip"
                        @click.prevent="action.callback(row, index, $event)">
                        <i :title="action.tooltip" class="fa" :class="action.icon"></i>
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="text-right text-bold" :colspan="stockTableFields.length">Total</td>
                  <!-- <td>{{ getFixed(outputData.inception.portfolio_index.inception_date) }}</td> -->
                  <td>{{ getFixed(outputData.inception.total_latest_value) }}</td>
                  
                </tr>
              </tbody>
              <tfoot v-if="outputData.inception.stockwise.length == 0">
                <tr>
                  <td :colspan="(stockTableFields.length + 1 + actions.length)">
                    <i class="fa fa-info cwhite"></i> No data found.
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div class="row">
            <div class="col-md-11">
              <h4 class="text-left">Returns across time periods</h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'inception-returns'" :fileName="'inception-returns'"></download>
            </div>
          </div>
          <div class="table-responsive app mb-15" v-dragscroll="true">
            <table id="inception-returns" class="table table-bordered">
              <thead>
                <tr>
                  <th></th>
                  <th v-for="(hd, index) in compositeIndex" :key="'portfolio' + index" class="text-center">{{ hd.name }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <!-- <tr v-for="let port of portfolios.sensex_index[1]"> -->
                <tr v-if="outputData.inception.portfolio_index">
                  <td>Portfolio Index</td>
                  <td v-for="(hd, index) in compositeIndex" :key="'portfoliotd' + index"
                    :class="{ 'text-right': hd.type === 'numeric' }">
                    <span v-if="hd.type === 'numeric'">{{ (hd.unit === '(%)') ?
                      getFixed(outputData.inception.portfolio_index[hd.title] * 100) :
                      getFixed(outputData.inception.portfolio_index[hd.title]) }}</span>
                    <span v-if="hd.type === 'string'">{{ outputData.inception.portfolio_index[hd.title] }}</span>
                  </td>
                </tr>
                <tr v-if="outputData.inception.composite_index">
                  <td>{{ 'Composite Index' }}</td>
                  <td v-for="(hd, index) in compositeIndex" :key="'Composite' + index"
                    :class="{ 'text-right': hd.type === 'numeric' }">
                    <span v-if="hd.type === 'numeric'">{{ (hd.unit === '(%)') ?
                      getFixed(outputData.inception.composite_index[hd.title] * 100) :
                      getFixed(outputData.inception.composite_index[hd.title]) }}</span>
                    <span v-if="hd.type === 'string'">{{ outputData.inception.composite_index[hd.title] }}</span>
                  </td>
                </tr>
                <tr v-if="outputData.inception.sensex_index">
                  <td>{{ outputData.inception.sensex_index[1].ind_type }}</td>
                  <td v-for="(hd, index) in compositeIndex" :key="'large' + index"
                    :class="{ 'text-right': hd.type === 'numeric' }">
                    <span v-if="hd.type === 'numeric'">{{ (hd.unit === '(%)') ?
                      getFixed(outputData.inception.sensex_index[1][hd.title] * 100) :
                      getFixed(outputData.inception.sensex_index[1][hd.title]) }}</span>
                    <span v-if="hd.type === 'string'">{{ outputData.inception.sensex_index[1][hd.title] }}</span>
                  </td>
                </tr>
                <tr v-if="outputData.inception.sensex_index">
                  <td>{{ outputData.inception.sensex_index[0].ind_type }}</td>
                  <td v-for="(hd, index) in compositeIndex" :key="'bsesen' + index"
                    :class="{ 'text-right': hd.type === 'numeric' }">
                    <span v-if="hd.type === 'numeric'">{{ (hd.unit === '(%)') ?
                      getFixed(outputData.inception.sensex_index[0][hd.title] * 100) :
                      getFixed(outputData.inception.sensex_index[0][hd.title]) }}</span>
                    <span v-if="hd.type === 'string'">{{ outputData.inception.sensex_index[0][hd.title] }}</span>
                  </td>
                </tr>
                <tr v-if="outputData.inception.sensex_index">
                  <td>{{ outputData.inception.sensex_index[2].ind_type }}</td>
                  <td v-for="(hd, index) in compositeIndex" :key="'mid' + index"
                    :class="{ 'text-right': hd.type === 'numeric' }">
                    <span v-if="hd.type === 'numeric'">{{ (hd.unit === '(%)') ?
                      getFixed(outputData.inception.sensex_index[2][hd.title] * 100) :
                      getFixed(outputData.inception.sensex_index[2][hd.title]) }}</span>
                    <span v-if="hd.type === 'string'">{{ outputData.inception.sensex_index[2][hd.title] }}</span>
                  </td>
                </tr>
                <tr v-if="outputData.inception.sensex_index">
                  <td>{{ outputData.inception.sensex_index[3].ind_type }}</td>
                  <td v-for="(hd, index) in compositeIndex" :key="'sm' + index"
                    :class="{ 'text-right': hd.type === 'numeric' }">
                    <span v-if="hd.type === 'numeric'">{{ (hd.unit === '(%)') ?
                      getFixed(outputData.inception.sensex_index[3][hd.title] * 100) :
                      getFixed(outputData.inception.sensex_index[3][hd.title]) }}</span>
                    <span v-if="hd.type === 'string'">{{ outputData.inception.sensex_index[3][hd.title] }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-11">
                <h4>
                  Market Cap-wise
                  <small>Date: {{ getDate(outputData.inception.inception_date) }}</small>
                </h4>
              </div>
              <div class="col-md-1">
                <download :tableId="'inception-mcap'" :fileName="'inception-mcap'"></download>
              </div>
            </div>
            <div class="table-responsive app mb-15" v-dragscroll="true">
              <table id="inception-mcap" class="table">
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th v-for="field in mcapTableFields" v-bind:key="'field' + field.title">{{ field.name }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in outputData.inception.industrywise" v-bind:key="'row' + index">
                    <td>{{ index + 1 }}</td>
                    <td v-for="field in mcapTableFields" v-bind:key="field.title + index">
                      <span v-if="field.type === 'string'">{{ getCustomLabel(row[field.title]) }}</span>
                      <span v-else>
                        <span v-if="field.unit === '(%)'">{{ (row[field.title]) ? getFixed(row[field.title] * 100) :
                          row[field.title] }}</span>
                        <span v-else>{{ getCustomLabel(row[field.title]) }}</span>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!--------------LATEST ------------------->
      <div class="row mb5">
        <!-- <div class="row mb5"> -->
        <div class="col-md-10">
          <h3 class="text-center">Latest <small v-if="outputData.latest.stockwise.length">Date:
              {{ getDate(outputData.latest.stockwise[0].latest_date) }}</small></h3>
        </div>
        <!-- <div class="col-md-1"></div> -->
        <!-- </div> -->

        <div class="col-md-12">
          <div class="row">
            <div class="col-md-11">
              <h4 class="text-left"></h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'latest-portfolio-value'" :fileName="'latest-portfolio-value'"></download>
            </div>
          </div>
          <div class="table-responsive app mb-15" v-dragscroll="true">
            <table id="latest-portfolio-value" class="table table-sm first-td-padding table-bordered app-inner">
              <thead>
                <tr>
                  <th>Sr.</th>
                  <th v-for="field in stockTableFields1" v-bind:key="'field' + field.title">{{ field.name }}</th>
                  <th v-if="actions.length > 0">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in outputData.latest.stockwise" v-bind:key="'row' + index">
                  <td>{{ index + 1 }}</td>
                  <td v-for="field in stockTableFields1" v-bind:key="field.name">
                    <span v-if="field.type === 'string'">
                      <span v-if="field.title === 'industry_type'">{{ getCustomLabel(row[field.title]) }}</span>
                      <span v-else>{{ row[field.title] }}</span>
                    </span>
                    <span v-else-if="field.type === 'number'">{{ getFixed(row[field.title]) }}</span>
                    <span v-else-if="field.type === 'date'">{{ getDate(row[field.title]) }}</span>
                    <span v-else>{{ row[field.title] }}</span>
                  </td>
                  <td v-if="actions.length > 0">
                    <div class="action-btn-wrapper">
                      <a style="margin:1px 4px" class="btn btn-sm btn-small" :class="action.btnClass"
                        v-for="(action, index) in actions" v-bind:key="index + '-action-' + action.tooltip"
                        @click.prevent="action.callback(row, index, $event)">
                        <i :title="action.tooltip" class="fa" :class="action.icon"></i>
                      </a>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="text-right text-bold" :colspan="stockTableFields1.length">Total</td>
                  <td>{{ getFixed(outputData.latest.total_latest_value) }}</td>
                </tr>
              </tbody>
              <tfoot v-if="outputData.latest.stockwise.length == 0">
                <tr>
                  <td :colspan="(stockTableFields.length + 1 + actions.length)">
                    <i class="fa fa-info cwhite"></i> No data found.
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div class="row">
            <div class="col-md-11">
              <h4 class="text-left">Returns across time periods <small>(In %)</small></h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'latest-returns'" :fileName="'latest-returns'"></download>
            </div>
          </div>
          <div class="table-responsive app mb-15" v-dragscroll="true">
            <table id="latest-returns" class="table table-bordered">
              <thead>
                <tr>
                  <th></th>
                  <th v-for="(hd, index) in compositeIndex1" :key="'portfolio' + index" class="text-center">{{ hd.name
                  }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <!-- <tr v-for="let port of portfolios.sensex_index[1]"> -->
                <tr v-if="outputData.latest.portfolio_index">
                  <td>Portfolio Index</td>
                  <td v-for="(hd, index) in compositeIndex1" :key="'portfoliotd' + index"
                    :class="{ 'text-right': hd.type === 'numeric' }">
                    <span v-if="hd.type === 'numeric'">{{ (hd.unit === '(%)') ?
                      getFixed(outputData.latest.portfolio_index[hd.title] * 100) :
                      getFixed(outputData.latest.portfolio_index[hd.title]) }}</span>
                    <span v-if="hd.type === 'string'">{{ outputData.latest.portfolio_index[hd.title] }}</span>
                  </td>
                </tr>
                <tr v-if="outputData.latest.composite_index">
                  <td>{{ 'Composite Index' }}</td>
                  <td v-for="(hd, index) in compositeIndex1" :key="'Composite' + index"
                    :class="{ 'text-right': hd.type === 'numeric' }">
                    <span v-if="hd.type === 'numeric'">{{ (hd.unit === '(%)') ?
                      getFixed(outputData.latest.composite_index[hd.title] * 100) :
                      getFixed(outputData.latest.composite_index[hd.title]) }}</span>
                    <span v-if="hd.type === 'string'">{{ outputData.latest.composite_index[hd.title] }}</span>
                  </td>
                </tr>
                <tr v-if="outputData.latest.sensex_index">
                  <td>{{ outputData.latest.sensex_index[1].ind_type }}</td>
                  <td v-for="(hd, index) in compositeIndex1" :key="'large' + index"
                    :class="{ 'text-right': hd.type === 'numeric' }">
                    <span v-if="hd.type === 'numeric'">{{ (hd.unit === '(%)') ?
                      getFixed(outputData.latest.sensex_index[1][hd.title] * 100) :
                      getFixed(outputData.latest.sensex_index[1][hd.title]) }}</span>
                    <span v-if="hd.type === 'string'">{{ outputData.latest.sensex_index[1][hd.title] }}</span>
                  </td>
                </tr>
                <tr v-if="outputData.latest.sensex_index">
                  <td>{{ outputData.latest.sensex_index[0].ind_type }}</td>
                  <td v-for="(hd, index) in compositeIndex1" :key="'bsesen' + index"
                    :class="{ 'text-right': hd.type === 'numeric' }">
                    <span v-if="hd.type === 'numeric'">{{ (hd.unit === '(%)') ?
                      getFixed(outputData.latest.sensex_index[0][hd.title] * 100) :
                      getFixed(outputData.latest.sensex_index[0][hd.title]) }}</span>
                    <span v-if="hd.type === 'string'">{{ outputData.latest.sensex_index[0][hd.title] }}</span>
                  </td>
                </tr>
                <tr v-if="outputData.latest.sensex_index">
                  <td>{{ outputData.latest.sensex_index[2].ind_type }}</td>
                  <td v-for="(hd, index) in compositeIndex1" :key="'mid' + index"
                    :class="{ 'text-right': hd.type === 'numeric' }">
                    <span v-if="hd.type === 'numeric'">{{ (hd.unit === '(%)') ?
                      getFixed(outputData.latest.sensex_index[2][hd.title] * 100) :
                      getFixed(outputData.latest.sensex_index[2][hd.title]) }}</span>
                    <span v-if="hd.type === 'string'">{{ outputData.latest.sensex_index[2][hd.title] }}</span>
                  </td>
                </tr>
                <tr v-if="outputData.latest.sensex_index">
                  <td>{{ outputData.latest.sensex_index[3].ind_type }}</td>
                  <td v-for="(hd, index) in compositeIndex1" :key="'sm' + index"
                    :class="{ 'text-right': hd.type === 'numeric' }">
                    <span v-if="hd.type === 'numeric'">{{ (hd.unit === '(%)') ?
                      getFixed(outputData.latest.sensex_index[3][hd.title] * 100) :
                      getFixed(outputData.latest.sensex_index[3][hd.title]) }}</span>
                    <span v-if="hd.type === 'string'">{{ outputData.latest.sensex_index[3][hd.title] }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-md-11">
                <h4>Market Cap-wise (Latest)</h4>
              </div>
              <div class="col-md-1">
                <download :tableId="'latest-mcap'" :fileName="'latest-mcap'"></download>
              </div>
            </div>
            <div class="table-responsive app mb-15" v-dragscroll="true">
              <table id="latest-mcap" class="table">
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th v-for="field in mcapTableFields" v-bind:key="'field' + field.title">{{ field.name }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in outputData.latest.industrywise" v-bind:key="'row' + index">
                    <td>{{ index + 1 }}</td>
                    <td v-for="field in mcapTableFields" v-bind:key="field.title + index">
                      <span v-if="field.type === 'string'">{{ getCustomLabel(row[field.title]) }}</span>
                      <span v-else>
                        <span v-if="field.unit === '(%)'">{{ (row[field.title]) ? getFixed(row[field.title] * 100) :
                          row[field.title] }}</span>
                        <span v-else>{{ getCustomLabel(row[field.title]) }}</span>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!------------ CHANGES DATA ------------>
      <div class="row">
        <div class="col-md-11">
          <h4 class="text-left">Changes in portfolio since inception</h4>
        </div>
        <div class="col-md-1">
          <download :tableId="'changes-portfolio-value'" :fileName="'changes-portfolio-value'"></download>
        </div>
      </div>
      <div class="table-responsive app mb-15" v-dragscroll="true">
        <table id="changes-portfolio-value" class="table table-sm first-td-padding table-bordered app-inner">
          <thead>
            <tr>
              <th>Sr.</th>
              <th v-for="field in changesTableFields" v-bind:key="'field' + field.title">{{ field.name }}</th>
              <th v-if="actions.length > 0">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in outputData.change" v-bind:key="'row' + index">
              <td>{{ index + 1 }}</td>
              <td v-for="field in changesTableFields" v-bind:key="field.name">
                <span v-if="field.type === 'string'">
                  <span v-if="field.title === 'industry_type'">{{ getCustomLabel(row[field.title]) }}</span>
                  <span v-else>{{ (row[field.title] !== '') ? row[field.title] == null ? '-' : row[field.title] : '-'
                  }}</span>
                </span>
                <span v-else-if="field.type === 'number'">{{ (row[field.title] !== '') ? getFixed(row[field.title]) :
                  '-'
                }}</span>
                <span v-else-if="field.type === 'date'">
                  <span v-if="row['no_of_share_sold'] !== '' && field.title === 'date_of_sale'">{{
                    getDate(row['date_of_sale']) }}</span>
                  <span v-else-if="row['no_of_share_purchased'] !== '' && field.title === 'date_of_purchase'">{{
                    getDate(row['date_of_purchase']) }}</span>
                  <span v-else>-</span>
                </span>
                <span v-else>{{ (row[field.title] !== '') ? row[field.title] : '-' }}</span>
              </td>
              <td v-if="actions.length > 0">
                <div class="action-btn-wrapper">
                  <a style="margin:1px 4px" class="btn btn-sm btn-small" :class="action.btnClass"
                    v-for="(action, index) in actions" v-bind:key="index + '-action-' + action.tooltip"
                    @click.prevent="action.callback(row, index, $event)">
                    <i :title="action.tooltip" class="fa" :class="action.icon"></i>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="outputData.latest.stockwise.length == 0">
            <tr>
              <td :colspan="(stockTableFields.length + 1 + actions.length)">
                <i class="fa fa-info cwhite"></i> No data found.
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <!------- CORPORATE ACTION - START -->
      <div class="row">
        <div class="col-md-11">
          <h3 class="text-center">Corporate Action</h3>
        </div>
      </div>
      <div>
        <div>
          <!-- Bonus Actions -->
          <div class="mb-4">
            <div class="row">
              <div class="col-md-11">
                <h4>Bonus Actions</h4>
              </div>
              <div class="col-md-1">
                <download :tableId="'bonus-actions-table'" :fileName="'bonus-actions-table'"></download>
              </div>
            </div>
            <div class="table-responsive app mb-15" v-dragscroll="true">
              <table id="bonus-actions-table" class="table table-sm first-td-padding table-bordered app-inner">
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th v-for="field in bonusTableFields" :key="'bonus-field-' + field.title">
                      {{ field.name }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in corporateActionData.bonus_actions" :key="'bonus-row-' + index">
                    <td>{{ index + 1 }}</td>
                    <td v-for="field in bonusTableFields" :key="'bonus-col-' + field.title">
                      <span v-if="field.type === 'date'">
                        {{ getDate(row[field.title]) }}
                      </span>
                      <span v-else>
                        {{ row[field.title] !== null && row[field.title] !== '' ? row[field.title] : '-' }}
                      </span>
                    </td>
                  </tr>
                  <tr v-if="!corporateActionData.bonus_actions.length">
                    <td :colspan="bonusTableFields.length + 1">No data found.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Split Actions -->
          <div class="mb-4">
            <div class="row">
              <div class="col-md-11">
                <h4>Split Actions</h4>
              </div>
              <div class="col-md-1">
                <download :tableId="'split-actions-table'" :fileName="'split-actions-table'"></download>
              </div>
            </div>
            <div class="table-responsive app mb-15" v-dragscroll="true">
              <table id="split-actions-table" class="table table-sm first-td-padding table-bordered app-inner">
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th v-for="field in splitTableFields" :key="'split-field-' + field.title">
                      {{ field.name }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in corporateActionData.split_actions" :key="'split-row-' + index">
                    <td>{{ index + 1 }}</td>
                    <td v-for="field in splitTableFields" :key="'split-col-' + field.title">
                      <span v-if="field.type === 'date'">
                        {{ getDate(row[field.title]) }}
                      </span>
                      <span v-else>
                        {{ row[field.title] !== null && row[field.title] !== '' ? row[field.title] : '-' }}
                      </span>
                    </td>
                  </tr>
                  <tr v-if="!corporateActionData.split_actions.length">
                    <td :colspan="splitTableFields.length + 1">No data found.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- Rights Actions -->
          <div class="mb-4">
            <div class="row">
              <div class="col-md-11">
                <h4>Rights Actions</h4>
              </div>
              <div class="col-md-1">
                <download :tableId="'rights-actions-table'" :fileName="'rights-actions-table'"></download>
              </div>
            </div>
            <div class="table-responsive app mb-15" v-dragscroll="true">
              <table id="rights-actions-table" class="table table-sm first-td-padding table-bordered app-inner">
                <thead>
                  <tr>
                    <th>Sr.</th>
                    <th v-for="field in rightsTableFields" :key="'rights-field-' + field.title">
                      {{ field.name }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in corporateActionData.rights_actions" :key="'rights-row-' + index">
                    <td>{{ index + 1 }}</td>
                    <td v-for="field in rightsTableFields" :key="'rights-col-' + field.title">
                      <span v-if="field.type === 'date'">
                        {{ getDate(row[field.title]) }}
                      </span>
                      <span v-else>
                        {{ row[field.title] !== null && row[field.title] !== '' ? row[field.title] : '-' }}
                      </span>
                    </td>
                  </tr>
                  <tr v-if="!corporateActionData.rights_actions.length">
                    <td :colspan="rightsTableFields.length + 1">No data found.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!------- CORPORATE ACTION - END -->
      <!------------- GRAPH DATA ------------>
      <div class="row mb5">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-11">
              <h4>Graph Data</h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'graph-data'" :fileName="'graph-data'"></download>
            </div>
          </div>
          <div class="table-responsive app mb-15" v-dragscroll="true">
            <table id="graph-data" class="table table-bordered">
              <thead>
                <tr>
                  <th></th>
                  <th>Date</th>
                  <th v-for="(hd, index) in graphData" :key="'portfolio-graph' + index" class="text-center">{{ hd.name
                  }}
                  </th>
                </tr>
              </thead>
              <tbody v-for="(port, index) in outputData.latest.PortfolioIndexGraph" v-bind:key="index + 'pgraph'">
                <tr
                  v-id="port.total_investment && outputData.latest.sensex_bse[index] && outputData.latest.sensex_500[index]">
                  <!-- <tr v-if="outputData.inception.portfolio_index"> -->
                  <td>{{ (index + 1) }}</td>
                  <td>{{ getDate(fixDate(port.date)) }}</td>
                  <td>{{ getFixed(port.total_investment) }}</td>
                  <td>{{ getFixed(port.index) }}</td>
                  <td>
                    <span v-if="outputData.latest.sensex_bse[index]">{{ outputData.latest.sensex_bse[index].IndexValue
                    }}</span>
                  </td>
                  <td>
                    <span v-if="sensexData[index]">{{ sensexData[index] }}</span>
                  </td>
                  <td>
                    <span v-if="outputData.latest.sensex_500[index]">{{ outputData.latest.sensex_500[index].IndexValue
                    }}</span>
                  </td>
                  <td>
                    <span v-if="bse500Data[index]">{{ bse500Data[index] }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <!-- </card> -->
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
export default {
  mixins: [commonMixins],
  name: "PortfolioReport",
  created() {
    if (!this.$route.params.id) {
      this.$router.push({ name: "portfolios" });
    }
    console.log("Config ", process.env.API_URL);
    this.portId = this.$route.params.id;
    this.pname = this.$route.params.name;
    this.fetchData();
    this.fetchCorporateActionData();
  },
  data() {
    return {
      pname: "",
      apiUrl: "portfolio/testing",
      apiCorporateActionUrl: "get/portfolio/corporate/actions",
      apiMode: true,
      company: {},
      actions: [],
      searchParams: {},
      sectorData: [],
      stockTableFields: [
        { title: "companyname", name: "Stock", type: "string", unit: "" },
        { title: "sectorname", name: "Sector", type: "string", unit: "" },
        { title: "market_cap", name: "Market Cap", type: "number", unit: "" },
        { title: "industry_type", name: "MCap Type", type: "string", unit: "" },
        {
          title: "date_of_purchase",
          name: "Purchase Date",
          type: "date",
          unit: ""
        },
        {
          title: "price_per_share",
          name: "Price on Inception Date",
          type: "number",
          unit: ""
        },
        {
          title: "no_of_share_purchased",
          name: "No of stock purchased",
          type: "string",
          unit: ""
        },
        {
          title: "no_of_share_sold",
          name: "No of stock sold",
          type: "string",
          unit: ""
        },
        {
          title: "no_of_share_held",
          name: "No of stock held",
          type: "string",
          unit: ""
        },
        {
          /* title: "price_no_of_share_inception_date_price", */
          title: "latest_value",
          name: "Value on Inception Date",
          type: "number",
          unit: ""
        }
        // {
        //   title: "latest_value",
        //   name: "Latest Value",
        //   type: "number",
        //   unit: ""
        // }
      ],
      stockTableFields1: [
        { title: "companyname", name: "Stock", type: "string", unit: "" },
        { title: "sectorname", name: "Sector", type: "string", unit: "" },
        { title: "market_cap", name: "Market Cap", type: "number", unit: "" },
        { title: "industry_type", name: "MCap Type", type: "string", unit: "" },
        { title: "latest_date", name: "Latest Date", type: "date", unit: "" },
        {
          title: "latest_price",
          name: "Latest Price",
          type: "number",
          unit: ""
        },
        {
          title: "no_of_share_purchased",
          name: "No of stock purchased",
          type: "string",
          unit: ""
        },
        {
          title: "no_of_share_sold",
          name: "No of stock sold",
          type: "string",
          unit: ""
        },
        {
          title: "no_of_share_held",
          name: "No of stock held",
          type: "string",
          unit: ""
        },
        {
          title: "latest_value",
          name: "Latest Value",
          type: "number",
          unit: ""
        }
      ],
      mcapTableFields: [
        {
          title: "ind_type",
          name: "Market Cap Type",
          type: "string",
          unit: ""
        },
        {
          title: "latest_value_by_total_value",
          name: "LV/TV",
          type: "number",
          unit: "(%)"
        }
      ],
      outputData: [],
      corporateActionData: {
        bonus_actions: [],
        split_actions: [],
        rights_actions: []
      },
      compositeIndex: [
        // {title: 'ind_type', name: , type: 'numeric', unit: ''},
        { title: "latest", name: "Latest", type: "numeric", unit: "" },
        { title: "one_day", name: "1 Day", type: "numeric", unit: "" },
        { title: "one_week", name: "1 Week", type: "numeric", unit: "" },
        { title: "one_month", name: "1 Month", type: "numeric", unit: "" },
        { title: "three_month", name: "3 Month", type: "numeric", unit: "" },
        { title: "six_month", name: "6 Month", type: "numeric", unit: "" },
        { title: "one_year", name: "1 Year", type: "numeric", unit: "" },
        { title: "two_year", name: "2 Year", type: "numeric", unit: "" },
        { title: "three_year", name: "3 Year", type: "numeric", unit: "" },
        { title: "five_year", name: "5 Year", type: "numeric", unit: "" },
        {
          title: "inception_date",
          name: "Since Inception",
          type: "numeric",
          unit: ""
        }
      ],
      compositeIndex1: [
        // {title: 'ind_type', name: , type: 'numeric', unit: ''},
        // { title: "latest", name: "Latest", type: "numeric", unit: "(%)" },
        { title: "one_day", name: "1 Day", type: "numeric", unit: "(%)" },
        { title: "one_week", name: "1 Week", type: "numeric", unit: "(%)" },
        { title: "one_month", name: "1 Month", type: "numeric", unit: "(%)" },
        { title: "three_month", name: "3 Month", type: "numeric", unit: "(%)" },
        { title: "six_month", name: "6 Month", type: "numeric", unit: "(%)" },
        { title: "one_year", name: "1 Year", type: "numeric", unit: "(%)" },
        { title: "two_year", name: "2 Year", type: "numeric", unit: "(%)" },
        { title: "three_year", name: "3 Year", type: "numeric", unit: "(%)" },
        { title: "five_year", name: "5 Year", type: "numeric", unit: "(%)" },
        {
          title: "inception_date",
          name: "Since Inception",
          type: "numeric",
          unit: "(%)"
        }
      ],
      graphData: [
        { title: "portfolio", name: "Portfolio" },
        { title: "portfolio_index", name: "Portfolio Index" },
        { title: "sensex_bse", name: "BSE Sensex" },
        { title: "sensex_bse_index", name: "BSE Sensex Index" },
        { title: "sensex_500", name: "BSE Sensex 500" },
        { title: "sensex_500_index", name: "BSE Sensex 500 Index" }
      ],
      /* corporateActionTableFields: [
        { title: "co_code", name: "Company Code", type: "string", unit: "" },
        { title: "companyname", name: "Company Name", type: "string", unit: "" },
        { title: "record_date", name: "Record Date", type: "date", unit: "" },
        { title: "bonus_ratio", name: "Bonus Ratio", type: "string", unit: "" },
        { title: "bonus_share", name: "Bonus Share", type: "string", unit: "" },
        {
          title: "no_of_share_after_bonus",
          name: "No of Share After Bonus",
          type: "string",
          unit: ""
        }
      ], */
      bonusTableFields: [
        { title: "co_code", name: "Company Code", type: "string" },
        { title: "companyname", name: "Company Name", type: "string" },
        { title: "record_date", name: "Record Date", type: "date" },
        { title: "bonus_ratio", name: "Bonus Ratio", type: "string" },
        { title: "bonus_share", name: "Bonus Share", type: "string" },
        { title: "no_of_share_after_bonus", name: "No of Share After Bonus", type: "string" }
      ],

      splitTableFields: [
        { title: "co_code", name: "Company Code", type: "string" },
        { title: "companyname", name: "Company Name", type: "string" },
        { title: "record_date", name: "Record Date", type: "date" },
        { title: "split_ratio", name: "Split Ratio", type: "string" },
        { title: "split_share", name: "Split Share", type: "string" },
        { title: "no_of_share_after_split", name: "No of Share After Split", type: "string" }
      ],

      rightsTableFields: [
        { title: "co_code", name: "Company Code", type: "string" },
        { title: "companyname", name: "Company Name", type: "string" },
        { title: "record_date", name: "Record Date", type: "date" },
        { title: "rights_ratio", name: "Rights Ratio", type: "string" },
        { title: "rights_share", name: "Rights Share", type: "string" },
        { title: "price_of_rights_issue", name: "Rights Issue Price", type: "string" },
        { title: "no_of_share_after_rights", name: "No of Share After Rights", type: "string" }
      ],
      changesTableFields: [
        { title: "companyname", name: "Stock", type: "string", unit: "" },
        // { title: "sectorname", name: "Sector", type: "string", unit: "" },
        // { title: "market_cap", name: "Market Cap", type: "number", unit: "" },
        // { title: "industry_type", name: "MCap Type", type: "string", unit: "" },
        { title: "corporate_action", name: "Corporate Action", type: "string", unit: "" },
        {
          title: "price_per_share",
          name: "Price per share",
          type: "number",
          unit: ""
        },
        {
          title: "date_of_purchase",
          name: "Purchase Date",
          type: "date",
          unit: ""
        },
        {
          title: "no_of_share_purchased",
          name: "No of stock purchased",
          type: "string",
          unit: ""
        },
        {
          title: "price_at_which_sold",
          name: "Sell Price",
          type: "number",
          unit: ""
        },
        {
          title: "date_of_sale",
          name: "Sell Date",
          type: "date",
          unit: ""
        },
        {
          title: "no_of_share_sold",
          name: "No of stock sold",
          type: "string",
          unit: ""
        },
        // {
        //   title: "no_of_share_held",
        //   name: "No of stock held",
        //   type: "string",
        //   unit: ""
        // },
        // {
        //   title: "price_no_of_share_inception_date_price",
        //   name: "Value on Inception Date",
        //   type: "number",
        //   unit: ""
        // }
        // {
        //   title: "latest_value",
        //   name: "Latest Value",
        //   type: "number",
        //   unit: ""
        // }
      ],
      sensexData: [],
      bse500Data: []
    };
  },
  methods: {
    /* formatDate(date) {
      if (!date) return "-";
      return new Date(date).toLocaleDateString("en-IN");
    }, */
    fetchData(data) {
      console.log("=====" + this.url + "========");
      let myself = this;
      http.post(this.apiUrl, { portfolio_id: this.portId }, function (
        error,
        response
      ) {
        console.log(response);
        myself.outputData = response;
        myself.getIndexValues();
      });
    },
    fetchCorporateActionData() {
      let myself = this;
      console.log("=====" + myself.apiCorporateActionUrl + "========");

      http.post(myself.apiCorporateActionUrl, { portfolio_id: myself.portId }, function (
        error,
        response
      ) {
        console.log("### Corporate Action: ", response);
        if (response.status === "success") {
          myself.corporateActionData = response.data;
        }
        //myself.getIndexValues();
      });
    },
    getIndexValues() {
      this.outputData.inception.sensex_bse.forEach((val, key) => {
        console.log(val);
        // this.groupLabels.push(val["IndexDate"]); //.substring(0, val["my_date"].indexOf("T")));
        this.sensexData.push(val["IndexValue"]);
      });
      this.outputData.inception.sensex_500.forEach((val, key) => {
        // this.groupLabels.push(val["IndexDate"]); //.substring(0, val["my_date"].indexOf("T")));
        this.bse500Data.push(val["IndexValue"]);
      });
      this.bse500Data = this.getDataInRatio(this.bse500Data);
      this.sensexData = this.getDataInRatio(this.sensexData);
      console.log(this.bse500Data, this.sensexData);
    }
  }
};
</script>
<style>
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/portfolios/portfolio-test-reports.vue